import AppEvent from '../helpers/appEvent'
import Service from '../services/logout'
import urlHelper from '../helpers/url'
import CookieHelper from '../../common/helpers/cookieHelper'
import smartlock from '../../common/smartlock'

const clientLogout = () => {
    return new Promise((resolve, reject) => {
        window.smartlock && window.smartlock.signOut();
        CookieHelper.deleteAllCookies();
        AppEvent.sendEvent('LOGINTO');
        resolve();
    })
}

const logout = async (isVoluntary) => {
    if (window.UserClientLibs && window.UserClientLibs.LogoutAsync) {
        return await window.UserClientLibs.LogoutAsync({ embedShortCircuit: false, redirectToLogin: true , isVoluntary}); 
    }
}

export default logout;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/logout.js